<mat-card *ngIf="paramsCartes">
    <mat-card-title>
        <span [translate]="'admin.frais.ndf.onglets.fraisCartes.antiDoublon.title'"></span>
    </mat-card-title>
    <mat-card-content>
        <form>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="plusieursImports"
                                  name="plusieursImports"
                                  libelle="admin.frais.ndf.onglets.fraisCartes.antiDoublon.plusieursImports"
                                  postLibelle="admin.frais.ndf.onglets.fraisCartes.antiDoublon.plusieursImportsLibelle"
                                  [postTooltip]="'admin.frais.ndf.onglets.fraisCartes.antiDoublon.plusieursImportsTooltip' | translate"
                                  [ngModel]="paramsCartes.antiDoublonInterLot"
                                  [(customModel)]="paramsCartes.antiDoublonInterLot"
                                  [lCol]="3" [rCol]="8"
                                  (onChange)="onChangeAntiDoublonInterLot()"
                                  customType="checkbox">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="memeImport"
                                  name="memeImport"
                                  libelle="admin.frais.ndf.onglets.fraisCartes.antiDoublon.memeImport"
                                  postLibelle="admin.frais.ndf.onglets.fraisCartes.antiDoublon.memeImportLibelle"
                                  [ngModel]="paramsCartes.antiDoublonIntraLot"
                                  [(customModel)]="paramsCartes.antiDoublonIntraLot"
                                  [lCol]="3" [rCol]="8"
                                  [disabled]="!paramsCartes.antiDoublonInterLot"
                                  (onChange)="onChangeAntiDoublonIntraLot()"
                                  customType="checkbox">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="memeFichier"
                                  name="memeFichier"
                                  libelle="admin.frais.ndf.onglets.fraisCartes.antiDoublon.memeFichier"
                                  postLibelle="admin.frais.ndf.onglets.fraisCartes.antiDoublon.memeFichierLibelle"
                                  [ngModel]="paramsCartes.antiDoublonIntraFichier"
                                  [(customModel)]="paramsCartes.antiDoublonIntraFichier"
                                  [lCol]="3" [rCol]="8"
                                  [disabled]="!paramsCartes.antiDoublonIntraLot"
                                  customType="checkbox">
                    </custom-input>
                </div>
            </fieldset>
        </form>
    </mat-card-content>
</mat-card>
<mat-card *ngIf="paramsCartes">
    <mat-card-title>
        <span [translate]="'admin.frais.ndf.onglets.fraisCartes.debitCollab.title'"></span>
    </mat-card-title>
    <mat-card-content>
        <form>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="depenseCollab"
                                  name="depenseCollab"
                                  libelle="admin.frais.ndf.onglets.fraisCartes.debitCollab.depenseCollab"
                                  postLibelle="admin.frais.ndf.onglets.fraisCartes.debitCollab.depenseCollabLibelle"
                                  [ngModel]="paramsCartes.depPersoCollab"
                                  [(customModel)]="paramsCartes.depPersoCollab"
                                  [lCol]="3" [rCol]="8"
                                  customType="checkbox">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="depenseAssistant"
                                  name="depenseAssistant"
                                  libelle="admin.frais.ndf.onglets.fraisCartes.debitCollab.depenseAssistant"
                                  postLibelle="admin.frais.ndf.onglets.fraisCartes.debitCollab.depenseAssistantLibelle"
                                  [ngModel]="paramsCartes.depPersoAssistant"
                                  [(customModel)]="paramsCartes.depPersoAssistant"
                                  [lCol]="3" [rCol]="8"
                                  customType="checkbox">
                    </custom-input>
                </div>
            </fieldset>
        </form>
    </mat-card-content>
</mat-card>
<mat-card *ngIf="paramsCartes">
    <mat-card-title>
        <span [translate]="'admin.frais.ndf.onglets.fraisCartes.debitEntreprise.title'"></span>
    </mat-card-title>
    <mat-card-content>
        <form>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="importDAB"
                                  name="importDAB"
                                  libelle="admin.frais.ndf.onglets.fraisCartes.debitEntreprise.importDAB"
                                  postLibelle="admin.frais.ndf.onglets.fraisCartes.debitEntreprise.importDABLibelle"
                                  [ngModel]="paramsCartes.retraitDAB"
                                  [(customModel)]="paramsCartes.retraitDAB"
                                  [lCol]="3" [rCol]="8"
                                  customType="checkbox">
                    </custom-input>
                </div>
            </fieldset>
        </form>
    </mat-card-content>
</mat-card>
<floating-button [listeActions]="listeActions" *ngIf="listeActions"></floating-button>
